// Wrapper mỏng quanh thư viện Tajima html5-embroidery (vendor cùng thư mục, MIT) để dùng trong React:
// parse file .DST hoàn toàn client-side (không cần Inkscape/Ink-Stitch) - đủ để tách zone theo thứ tự
// thêu (STOP flag = đổi màu, giống hệt luật DstZoneRenderer.GetStopSequence phía server C#) và vẽ line-art
// preview từng zone cho admin chọn màu, không cần round-trip server.
const jDataView = require("./jdataview");
const { Pattern, dstRead } = require("./dstformat");

/**
 * Parse 1 file DST (ArrayBuffer) thành danh sách zone theo đúng thứ tự thêu.
 * stitch.color (Pattern tự tăng mỗi khi gặp stitch có flag STOP) chính là ZoneIndex 0-based - khớp với
 * server (EMB_SizeZones.ZoneIndex / EMB_PatternEffectZones.ZoneIndex).
 * @returns {{width:number, height:number, zones: Array<{zoneIndex:number, stitchCount:number, stitches:Array}>}}
 */
export function parseDstZones(arrayBuffer) {
    const view = new jDataView(arrayBuffer, 0, arrayBuffer.byteLength);
    const pattern = new Pattern();
    dstRead(view, pattern);
    pattern.moveToPositive();

    const zonesByIndex = new Map();
    pattern.stitches.forEach((stitch) => {
        if (!zonesByIndex.has(stitch.color)) zonesByIndex.set(stitch.color, []);
        zonesByIndex.get(stitch.color).push(stitch);
    });
    const zoneIndexes = Array.from(zonesByIndex.keys()).sort((a, b) => a - b);

    return {
        width: Math.max(1, Math.ceil(pattern.right)),
        height: Math.max(1, Math.ceil(pattern.bottom)),
        zones: zoneIndexes.map((zoneIndex) => ({
            zoneIndex,
            stitchCount: zonesByIndex.get(zoneIndex).length,
            stitches: zonesByIndex.get(zoneIndex),
        })),
    };
}

/**
 * Vẽ line-art 1 zone lên canvas (co giãn vừa khung, giữ tỉ lệ) - dùng logic vẽ giống Pattern.drawShape gốc
 * nhưng chỉ vẽ stitches của 1 zone, tô 1 màu (hex đang chọn hoặc xám mặc định khi chưa chọn).
 */
export function drawZoneStitches(canvas, stitches, hexColor, docWidth, docHeight) {
    if (!canvas || !stitches || stitches.length === 0) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const padding = 6;
    const scale = Math.min((canvas.width - padding * 2) / docWidth, (canvas.height - padding * 2) / docHeight) || 1;
    const offsetX = (canvas.width - docWidth * scale) / 2;
    const offsetY = (canvas.height - docHeight * scale) / 2;

    ctx.strokeStyle = hexColor || "#a0a0a0";
    ctx.lineWidth = 1.4;
    ctx.beginPath();
    let started = false;
    stitches.forEach((stitch) => {
        const x = offsetX + stitch.x * scale;
        const y = offsetY + stitch.y * scale;
        //flags != 0 (jump/trim/stop) = nhấc kim di chuyển - không vẽ nét nối, bắt đầu path mới tại đây
        if (stitch.flags || !started) {
            ctx.moveTo(x, y);
            started = true;
        } else {
            ctx.lineTo(x, y);
        }
    });
    ctx.stroke();
}
